/*=========================================================================================
  File Name: getters.js
  Description: Opening Hours Getters
  ----------------------------------------------------------------------------------------
  Item Name: Opening Hours State Module
  Author: Tan Tran
==========================================================================================*/
import Moment from 'moment';

export default {

    openingHourByLabel: state => label => {
        let openingHour = state.openingHours.find(p => p.label === label);
        return openingHour;
    },

    openingHourLabels : state => {
      console.log('openingHourLabels')
      let dataLabel = [];

      let from = state.fromTime.hour();
      let to = state.toTime.hour();

      for (let i=from; i <=to; i++) {
        dataLabel.push(i.toString());
        //console.log(i)
      }
      //console.log(dataLabel)
      return dataLabel;
    } 

    
}